<script setup lang="ts">
const items = [
  {
    title: 'Cair di Hari yang Sama',
    description: 'Dana COD bisa langsung dipakai untuk belanja atau produksi.',
    icon: 'ic:outline-payments'
  },
  {
    title: 'Proses Otomatis & Aman',
    description: 'Tanpa verifikasi manual yang makan waktu.',
    icon: 'material-symbols:published-with-changes'
  },
  {
    title: 'Paket Sampai Tujuan, Dana COD Rilis',
    description:
      'Dana COD rilis ke saldo aktif di hari yang sama setelah paket sampai tujuan',
    icon: 'material-symbols:quick-reorder-outline'
  },
  {
    title: 'Terpantau Real-Time',
    description:
      'Lihat status pencairan saldo COD langsung dari dashboard KiriminAja.',
    icon: 'material-symbols:timer-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Cair Tanpa Pending, Bukan Besok-Besok Lagi"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
